// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snorlax_gmax: PokeData = {
  "id": 10206,
  "name": "snorlax-gmax",
  "height": 350,
  "weight": 10000,
  "base_experience": 189,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [],
  "moves": [
    "scary-face",
    "protect",
    "body-slam",
    "splash",
    "headbutt",
    "quick-attack",
    "tackle",
    "scratch",
    "leer",
    "growl",
    "supersonic",
    "refresh"
  ],
  "evolution_chain": {
    "id": 72,
    "item": {
      "name": "full-incense"
    },
    "species": [
      {
        "name": "munchlax",
        "order": 174,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "snorlax",
        "order": 175,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 446,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 188,
    "speed": 45,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
